import React from 'react';
import { 
    useDisclosure, 
    Editable, 
    EditableInput, 
    EditablePreview, 
    IconButton 
} from '@chakra-ui/react';
import { SheetTitleEditableProps } from './Table.types';
import { BsTrash } from 'react-icons/bs';
import { SheetTitleContainer } from './Table.styles';

export default function TableSheetTitleEditable({
    sheet,
    onChange,
    onDelete,
  }: SheetTitleEditableProps) {
    const [input, setInput] = React.useState(sheet.name || "");
    // const { onOpen, onClose } = useDisclosure();
    const { onOpen } = useDisclosure();
  
    function handleChange(value: string) {
        setInput(value);
        onChange && onChange(value);
    }
  
    // function handleDelete() {
    //   onDelete && onDelete(sheet.id, onClose);
    // }
  
    return (
      <>
        <SheetTitleContainer>
          <Editable fontWeight={'semibold'} fontSize='md' value={input} onChange={handleChange} defaultValue={input}>
            <EditablePreview />
            <EditableInput />
          </Editable>
          <IconButton
              aria-label='delete icon'
              size="sm"
              variant="ghost"
              onClick={onOpen}
              marginLeft="0.5rem"
              colorScheme='red'
              _hover={{ color: 'rgb(183, 33, 54)' }}
              _focus={{ boxShadow: 'none', border: 'none', }}
              icon={<BsTrash />} 
          />
        </SheetTitleContainer>
        {/* <ConfirmModal
          isOpen={isOpen}
          onClose={onClose}
          title="Delete sheet"
          isLoading={isLoading}
          onConfirm={handleDelete}
        /> */}
      </>
    );
  }